import styleInject from '../../../external/style-inject/dist/style-inject.es.js';

var css_248z = "li.Item-module_item__0VNnU {\n  height: 96px;\n  padding: 0 24px;\n  cursor: pointer;\n}\n@media (min-width: 1000px) {\n  li.Item-module_item__0VNnU {\n    padding: 0 32px;\n  }\n}\nli.Item-module_item__0VNnU:not(:last-child)::after {\n  position: absolute;\n  bottom: -1px;\n  left: 24px;\n  display: block;\n  width: calc(100% - 24px - 24px);\n  height: 1px;\n  background-color: #dee0e2;\n  content: \"\";\n}";
var styles = {"item":"Item-module_item__0VNnU"};
styleInject(css_248z);

export { styles as default };
